export default __webpack_public_path__ + "static/media/x-icon.6c9a4ba7.svg";